import apiClient from './apiClient';
import { trackPromise } from 'react-promise-tracker';
import { offlineGet } from './helpers/offlineHelpers';

async function listDeparments() {
    const { data } = await trackPromise(apiClient.get('/api/department/getAll'));
    return data?.data ?? [];
}

async function listEnabledDeparments() {
    // const { data } = await trackPromise(apiClient.get('/api/department/getAll'));
    // return data?.data ?? [];
    return offlineGet(
        'departments_all',
        () => trackPromise(apiClient.get('/api/department/getAll')),
        (response) => response?.data?.data ?? []
    );
}

const departmentService = {
    listDeparments,
    listEnabledDeparments
};

export default departmentService;
